import * as React from "react";
import {useState, useEffect} from "react";
import { jfetch } from "../../utils";
import { toast } from "../../utils";
import PageContainer from "../core/PageContainer";
import ModernCard from "../core/ModernCard";

function getData(setData, keyString, time){
  jfetch.get(`/popular_page`, {time_filter: time}).then((resp) => {
    setData(resp[keyString])
  })
}

function MostPopular(props) {

  return (
    <PageContainer>
      <Courses courses={props.courses} timeFilter={props.timeFilter} />
      <Lessons lessons={props.lessons} timeFilter={props.timeFilter} />
      <ModernCard ta="left">
        <div>
          <h2>Most Popular Resources</h2>
        </div>
        {props.resources.map((resource) => {
          return (
            <div key={resource.id}>
              <p style={{color:'black'}}> 
                <a href={`/resources/${resource.id}`} style={{marginRight:'7px'}}>
                  "{resource.name}" 
                </a>
                {resource.cachedViews} views, created: {resource.createdAt} 
              </p>
            </div>
          )
        })}
      </ModernCard>      
    </PageContainer>
  );
}

function Lessons(props){

  const [lessons, setLessons] = useState(props.lessons)
  const [time, setTime] = useState('all')

  useEffect(() => {
    getData(setLessons, 'lessons', time)
  }, [time])
  return (
    <ModernCard ta="left">
    <div style={{display:'flex', justifyContent:'flex-end'}}>
      <select onChange={(e) => setTime(e.target.value)} style={{backgroundColor:'#2b4d7f',lineHeight:'initial', height:'initial', padding:'5px'}}>
        <option selected value={'all'}>All Time</option>
        {props.timeFilter.map( (o, i) => {
          return <option key={i} value={o.value}>{o.name}</option>
        })}
      </select>
    </div>      
    <div>
      <h2>Most Popular Lessons</h2>
    </div>
    {lessons.map((lesson) => {
      return (
        <div key={lesson.id}>
          <p style={{color:'black'}}> 
            <a href={`/library/lesson/${lesson.id}`} style={{marginRight:'7px'}}>
              "{lesson.title}" 
            </a>
            {lesson.viewCount} views, created: {lesson.createdAt} 
          </p>
        </div>
      )
    })}
  </ModernCard>
  )
}

function Courses(props){
  const [courses, setCourses] = useState(props.courses)
  const [time, setTime] = useState('all')

  useEffect(() => {
    getData(setCourses, 'courses', time)
  }, [time])  
  return (
    <ModernCard ta="left">
    <div style={{display:'flex', justifyContent:'flex-end'}}>
      <select onChange={(e) => setTime(e.target.value)} style={{backgroundColor:'#2b4d7f',lineHeight:'initial', height:'initial', padding:'5px'}}>
        <option selected value={'all'}>All Time</option>
        {props.timeFilter.map( (o, i) => {
          return <option key={i} value={o.value}>{o.name}</option>
        })}
      </select>
    </div>            
      <div>
        <h2>Most Popular Courses</h2>
      </div>
      {courses.map((course) => {
        return (
          <div key={course.id}>
            <p style={{color:'black'}}> 
              <a href={`/library/courses/${course.id}`} style={{marginRight:'7px'}}>
                "{course.title}" 
              </a>
              {course.views} total lesson views, created: {course.createdAt} 
            </p>
          </div>
        )
      })}
    </ModernCard> 
  )
}

export default MostPopular;



// WEBPACK FOOTER //
// ./app/javascript/components/pages/MostPopular.tsx